<div class="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
  <div class="container mx-auto px-4 py-8">

    <!-- Header -->
    <div class="mb-8">
      <div class="flex items-center mb-4">
        <div class="bg-gradient-to-r from-green-500 to-emerald-600 p-3 rounded-xl shadow-lg mr-4">
          <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-4m-5 0H9m0 0H7m2 0v-5a2 2 0 012-2h2a2 2 0 012 2v5m-6 0V9a2 2 0 012-2h2a2 2 0 012 2v8"></path>
          </svg>
        </div>
        <div>
          <h1 class="text-4xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">
            Reportes Bancarios
          </h1>
          <p class="text-gray-600 mt-1">Genera reportes detallados de movimientos y saldos bancarios</p>
        </div>
      </div>
    </div>

    <!-- Wizard Steps -->
    <div class="flex items-center justify-center mb-8">
      <div class="flex w-full max-w-2xl">
        <ng-container *ngFor="let label of ['Tipo de Reporte', 'Configuración']; let i = index">
          <div class="flex flex-1 text-center items-center">
            <div class="flex items-center justify-center w-10 h-10 rounded-full"
                 [ngClass]="{
                'bg-blue-500 text-white': step === i + 1,
                'bg-green-500 text-white': step > i + 1,
                'bg-gray-300 text-gray-600': step < i + 1
              }">
              <span *ngIf="step <= i + 1">{{ i + 1 }}</span>
              <svg *ngIf="step > i + 1" class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
              </svg>
            </div>
            <div class="mx-2 flex-1">
              <span class="text-sm font-medium">{{ label }}</span>
            </div>
            <div *ngIf="i < 1" class="flex-1 h-0.5 bg-gray-300"
                 [ngClass]="{'bg-blue-500': step > i + 1}"></div>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Main Content Card -->
    <form [formGroup]="reportForm" (ngSubmit)="downloadExcelReport()">
      <div class="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">

        <!-- STEP 1: Select Report Type -->
        <div *ngIf="step === 1">
          <div class="bg-gradient-to-r from-green-50 to-emerald-50 border-b border-gray-100 p-6">
            <h2 class="text-xl font-semibold text-gray-800 flex items-center">
              <svg class="w-5 h-5 mr-2 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
              </svg>
              Paso 1: Seleccione el Tipo de Reporte
            </h2>
          </div>
          <div class="p-6">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div *ngFor="let type of reportTypes"
                   class="border-2 rounded-lg p-4 cursor-pointer transition-all"
                   [ngClass]="{
                     'border-blue-500 bg-blue-50': reportForm.get('reportType')?.value === type.value,
                     'border-gray-200 hover:border-gray-300': reportForm.get('reportType')?.value !== type.value
                   }"
                   (click)="reportForm.get('reportType')?.setValue(type.value)">

                <div class="flex items-center mb-2">
                  <input type="radio"
                         [value]="type.value"
                         formControlName="reportType"
                         class="text-blue-600 focus:ring-blue-500">
                  <label class="ml-2 text-sm font-medium text-gray-900">
                    {{ type.icon }} {{ type.label }}
                  </label>
                </div>
                <p class="text-xs text-gray-500">{{ type.description }}</p>
              </div>
            </div>
            <div *ngIf="reportForm.get('reportType')?.invalid && reportForm.get('reportType')?.touched"
                 class="text-red-500 text-sm mt-2">
              Debe seleccionar un tipo de reporte
            </div>
          </div>
        </div>

        <!-- STEP 2: Configure Report -->
        <div *ngIf="step === 2">
          <!-- Card Header -->
          <div class="bg-gradient-to-r from-green-50 to-emerald-50 border-b border-gray-100 p-6">
            <h2 class="text-xl font-semibold text-gray-800 flex items-center">
              <svg class="w-5 h-5 mr-2 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
              </svg>
              Paso 2: Configuración del Reporte
            </h2>
            <p class="text-gray-600 text-sm mt-1">Seleccione los parámetros para generar el reporte</p>
          </div>

          <!-- Form Content -->
          <div class="p-6">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-8">

              <!-- Selector de Tipo de Fecha -->
              <div class="space-y-2">
                <label for="dateType" class="block text-sm font-semibold text-gray-700 flex items-center">
                  <svg class="w-4 h-4 mr-1 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                  </svg>
                  Tipo de Fecha *
                </label>
                <p-dropdown
                  id="dateType"
                  formControlName="dateType"
                  [options]="dateTypeOptions"
                  optionLabel="label"
                  optionValue="value"
                  class="w-full custom-dropdown">
                </p-dropdown>
                <div *ngIf="reportForm.get('dateType')?.invalid && reportForm.get('dateType')?.touched"
                     class="text-red-500 text-xs flex items-center mt-1">
                  <svg class="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                  </svg>
                  Este campo es requerido
                </div>
              </div>

              <!-- Selector de Meses -->
              <div class="space-y-2">
                <label for="months" class="block text-sm font-semibold text-gray-700">
                  <div class="flex items-center">
                    <svg class="w-4 h-4 mr-1 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                    </svg>
                    Meses *
                  </div>                  
                </label>
                <p-multiSelect
                  id="months"
                  formControlName="months"
                  [options]="monthsDropdown"
                  [showClear]="true"
                  [filter]="true"
                  placeholder="Seleccionar meses"
                  optionLabel="label"
                  optionValue="value"
                  [maxSelectedLabels]="3"
                  selectedItemsLabel="{0} meses seleccionados"
                  class="w-full custom-dropdown">
                </p-multiSelect>
                <div *ngIf="reportForm.get('months')?.invalid && reportForm.get('months')?.touched"
                     class="text-red-500 text-xs flex items-center mt-1">
                  <svg class="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                  </svg>
                  Debe seleccionar al menos un mes
                </div>
              </div>

              <!-- Selector de Año -->
              <div class="space-y-2">
                <label for="year" class="block text-sm font-semibold text-gray-700 flex items-center">
                  <svg class="w-4 h-4 mr-1 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                  </svg>
                  Año *
                </label>
                <p-dropdown
                  id="year"
                  formControlName="year"
                  [options]="yearsDropdown"
                  [filter]="true"
                  placeholder="Seleccionar año"
                  optionLabel="label"
                  optionValue="value"
                  class="w-full custom-dropdown">
                </p-dropdown>
                <div *ngIf="reportForm.get('year')?.invalid && reportForm.get('year')?.touched"
                     class="text-red-500 text-xs flex items-center mt-1">
                  <svg class="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                  </svg>
                  Este campo es requerido
                </div>
              </div>

              <!-- Selector de Banco -->
              <div class="space-y-2">
                <label for="bank" class="block text-sm font-semibold text-gray-700 flex items-center">
                  <svg class="w-4 h-4 mr-1 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-4m-5 0H9m0 0H7m2 0v-5a2 2 0 012-2h2a2 2 0 012 2v5m-6 0V9a2 2 0 012-2h2a2 2 0 012 2v8"></path>
                  </svg>
                  Banco *
                </label>
                <p-dropdown
                  id="bank"
                  formControlName="bank"
                  [options]="banksDropdown"
                  [showClear]="true"
                  [filter]="true"
                  placeholder="Seleccionar banco"
                  optionLabel="label"
                  optionValue="value"
                  class="w-full custom-dropdown">
                </p-dropdown>
                <div *ngIf="reportForm.get('bank')?.invalid && reportForm.get('bank')?.touched"
                     class="text-red-500 text-xs flex items-center mt-1">
                  <svg class="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                  </svg>
                  Este campo es requerido
                </div>
              </div>

              <!-- Selector de Año Inicial para Saldo -->
              <div class="space-y-2">
                <label for="initialBalanceYear" class="block text-sm font-semibold text-gray-700 flex items-center">
                  <svg class="w-4 h-4 mr-1 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                  Año Inicial Saldo
                </label>
                <input
                  type="number"
                  id="initialBalanceYear"
                  formControlName="initialBalanceYear"
                  class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="2026"
                  min="2020"
                  max="2030">
                <p class="text-xs text-gray-500 mt-1">Solo se considerarán transacciones desde el 1 de enero de este año para el cálculo del saldo inicial</p>
              </div>

              <!-- Selector de Participante (Filtro de Depuración) -->
              <div class="space-y-2">
                <label for="participantId" class="block text-sm font-semibold text-gray-700 flex items-center">
                  <svg class="w-4 h-4 mr-1 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                  </svg>
                  Participante (Opcional)
                </label>
                <p-dropdown
                  id="participantId"
                  formControlName="participantId"
                  [options]="participantsDropdown"
                  [showClear]="true"
                  [filter]="true"
                  placeholder="Todos los participantes"
                  optionLabel="label"
                  optionValue="value"
                  (onFilter)="onSearchParticipants($event)"
                  class="w-full custom-dropdown">
                </p-dropdown>
                <p class="text-xs text-gray-500 mt-1">Filtra el reporte a los movimientos asociados a un participante específico. Los Comprobantes de Egreso (CE) se omiten al usar este filtro.</p>
              </div>

            </div>

            <!-- Current Selection Display -->
            <div class="bg-gray-50 rounded-lg p-4 mb-6">
              <h3 class="text-lg font-semibold text-gray-800 mb-2">Selección Actual:</h3>
              <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 text-sm">
                <div>
                  <span class="font-medium text-gray-600">Tipo de Fecha:</span>
                  <span class="ml-2 text-gray-800">{{ selectedDateTypeName }}</span>
                </div>
                <div>
                  <span class="font-medium text-gray-600">Período:</span>
                  <span class="ml-2 text-gray-800">{{ selectedMonthsNames }} {{ selectedYear }}</span>
                </div>
                <div>
                  <span class="font-medium text-gray-600">Banco:</span>
                  <span class="ml-2 text-gray-800">{{ selectedBankName }}</span>
                </div>
                <div>
                  <span class="font-medium text-gray-600">Tipo:</span>
                  <span class="ml-2 text-green-600 font-medium">{{ getSelectedReport()?.label }}</span>
                </div>
                <div>
                  <span class="font-medium text-gray-600">Año Inicial:</span>
                  <span class="ml-2 text-gray-800">{{ selectedInitialBalanceYear }}</span>
                </div>
                <div>
                  <span class="font-medium text-gray-600">Participante:</span>
                  <span class="ml-2 text-gray-800">{{ selectedParticipantName }}</span>
                </div>
              </div>
            </div>

            <!-- Preview Section -->
            <div *ngIf="showPreview" class="bg-white rounded-lg border border-gray-200 p-4 mb-6">
              <h3 class="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                <svg class="w-5 h-5 mr-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                </svg>
                Previsualización del Reporte
              </h3>
              <div class="overflow-x-auto max-h-96 overflow-y-auto">
                <table class="min-w-full divide-y divide-gray-200 text-xs">
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr *ngFor="let row of previewData; let i = index" [ngClass]="{'bg-gray-100 font-semibold': i === 0}">
                      <td *ngFor="let cell of row" class="px-2 py-1 whitespace-nowrap border border-gray-200">
                        {{ cell }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="flex flex-col sm:flex-row justify-between gap-4 p-6 bg-gray-50 border-t">
          <button type="button"
                  *ngIf="step > 1"
                  (click)="goToStep(step - 1)"
                  class="px-8 py-3 bg-gray-200 text-gray-700 font-semibold rounded-xl hover:bg-gray-300 transition-all duration-200 flex items-center justify-center">
            <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd"></path>
            </svg>
            Atrás
          </button>

          <div *ngIf="step === 1"></div> <!-- Spacer -->

          <button type="button"
                  *ngIf="step < 2"
                  (click)="goToStep(step + 1)"
                  [disabled]="!isCurrentStepValid()"
                  class="px-8 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold rounded-xl shadow-lg hover:from-blue-700 hover:to-indigo-700 transform hover:scale-105 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center min-w-[200px]">
            Siguiente
            <svg class="w-4 h-4 ml-2" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path>
            </svg>
          </button>

          <div *ngIf="step === 2" class="flex gap-4">
            <button type="button"
                    (click)="previewReport()"
                    [disabled]="!isCurrentStepValid() || previewLoading"
                    class="px-8 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold rounded-xl shadow-lg hover:from-blue-700 hover:to-indigo-700 transform hover:scale-105 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center min-w-[200px]">

              <div *ngIf="previewLoading" class="flex items-center">
                <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-3"></div>
                <span>Cargando...</span>
              </div>

              <div *ngIf="!previewLoading" class="flex items-center">
                <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                </svg>
                <span>Previsualizar</span>
              </div>
            </button>

            <button type="submit"
                    [disabled]="!isCurrentStepValid() || loading"
                    class="px-8 py-3 bg-gradient-to-r from-green-600 to-emerald-600 text-white font-semibold rounded-xl shadow-lg hover:from-green-700 hover:to-emerald-700 transform hover:scale-105 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center min-w-[200px]">

              <div *ngIf="loading" class="flex items-center">
                <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-3"></div>
                <span>Generando Excel...</span>
              </div>

              <div *ngIf="!loading" class="flex items-center">
                <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"></path>
                </svg>
                <span>Descargar Excel</span>
              </div>
            </button>
          </div>
        </div>

      </div>
    </form>
    <!-- My Reports Section -->
    <app-recent-report-jobs></app-recent-report-jobs>

    <!-- Help Section -->
    <div class="mt-8 bg-white rounded-xl shadow-sm border border-gray-100 p-6">
      <div class="flex items-start">
        <div class="flex-shrink-0">
          <svg class="w-6 h-6 text-blue-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        </div>
        <div class="ml-4">
          <h4 class="text-lg font-medium text-gray-800">Información del Reporte</h4>
          <div class="mt-2 text-sm text-gray-600 space-y-1">
            <p>• Seleccione el tipo de reporte y los filtros deseados.</p>
            <p>• El <strong>reporte de movimientos</strong> incluye todos los movimientos bancarios (ingresos, egresos, saldos) del período seleccionado.</p>
            <p>• El <strong>reporte de saldos</strong> muestra un resumen con el saldo final de la cuenta a la fecha de corte.</p>
            <p>• Los datos se exportan en formato Excel (.xlsx) para facilitar su análisis.</p>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
